import { Component } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SmsFromNumbersService, UtilsService, UxHelperService } from '@shared/services';
import type { TSmsFromNumber } from '@shared/models';

@Component({
    'selector': 'app-smsfromnumbers',
    'templateUrl': './smsfromnumbers.page.html',
    'styleUrls': ['./smsfromnumbers.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class SmsFromNumbersPage implements OnInit, OnDestroy {
    private subscription: any;
    public submitted = false;
    public smsNumbers: TSmsFromNumber[] = [];
    public vm: TSmsFromNumber;

    constructor(
        private uxHelperService: UxHelperService, private smsFromNumbersService: SmsFromNumbersService,
        private utilsService: UtilsService) {
    }

    public async ngOnInit() {
        this.vm = this.smsFromNumbersService.getNullable();
        const observable = this.smsFromNumbersService.getObservable();
        this.subscription = observable.subscribe(async (numbers: TSmsFromNumber[]) => {
            this.smsNumbers = this.smsFromNumbersService.sort(numbers);
        });
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        // form.control.clearAsyncValidators();
        // form.control.markAsPristine();
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner();
            this.vm.numAccounts = 0;
            await this.smsFromNumbersService.set(this.vm, this.vm.fromNumber);
            this.vm = this.smsFromNumbersService.getNullable();
            this.submitted = false;
            form.resetForm();
            this.uxHelperService.showToast('Saved');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
